/* Palestinian Elegance: accessible, product-specific size chart presentation.
   Reads the EXISTING size chart rich text and converts identifiable size rows to
   a proper table. Does not modify Shopify product/metafield data. */
(function () {
  "use strict";

  function parseSizeRow(raw) {
    var text = String(raw || "")
      .replace(/[\u00a0\u2000-\u200b]/g, " ")
      .replace(/\s+/g, " ").trim()
      .replace(/^[\s•·\-📏]+/u, "").trim();
    var head = text.match(/^size\s+([0-9]{1,3}|[2-4]?xl|xxl|xs|s|m|l)\s*:?\s*/i);
    if (!head) return null;
    var size = head[1];
    var tail = text.slice(head[0].length);

    var bust = tail.match(/\b(?:bust|chest)(?:\s+(?:circumference|around))?\s*:?\s*(\d+(?:\.\d+)?)\s*["”]?/i);
    var length = tail.match(/\b(?:garment\s+)?length\s*:?\s*(\d+(?:\.\d+)?)\s*["”]?/i);
    var height = tail.match(/\b(?:fits?\s+)?height\s*:?\s*(.+)$/i);
    var inchMatches = Array.from(tail.matchAll(/(\d+(?:\.\d+)?)\s*["”]/g));
    var inches = inchMatches.map(function (m) { return m[1]; });
    var bustValue = bust ? bust[1] : null;
    var lengthValue = length ? length[1] : null;
    var heightValue = height ? height[1].trim() : null;
    var extras = "";

    // Some metaobjects use fixed-width rich text instead of a real table:
    // "Size 0    37\"    58.5\"    Thobe & Matching ...".
    // Only take the first two inch measurements when neither column is labelled.
    if (!bustValue && !lengthValue && inches.length >= 2) {
      bustValue = inches[0];
      lengthValue = inches[1];
      extras = tail.replace(/^\s*\d+(?:\.\d+)?\s*["”]\s*\d+(?:\.\d+)?\s*["”]\s*/, "").trim();
    }
    if (!lengthValue && heightValue && inches.length) lengthValue = inches[0];
    if (!bustValue && !lengthValue) return null;
    return { size: size, bust: bustValue, length: lengthValue, height: heightValue, extras: extras };
  }

  function makeCell(tag, content, cls) {
    var cell = document.createElement(tag);
    cell.textContent = content;
    if (cls) cell.className = cls;
    if (tag === "th") cell.scope = "col";
    return cell;
  }

  function renderChart(details) {
    if (!details || details.dataset.peChartReady === "1") return;
    var source = details.querySelector(".pe-pdp-size-disclosure__measurements");
    if (!source) return;

    var paragraphs = Array.from(source.querySelectorAll("p"));
    if (!paragraphs.length) return;
    var candidates = paragraphs.map(function (p) { return parseSizeRow(p.textContent); }).filter(Boolean);
    var unique = [];
    var seen = new Set();
    candidates.forEach(function (r) {
      if (!seen.has(r.size.toLowerCase())) {
        seen.add(r.size.toLowerCase());
        unique.push(r);
      }
    });

    // Safe fallback: leave the original formatted rich text unchanged if there
    // aren't at least two recognized measurements.
    if (unique.length < 2) return;
    var hasBust = unique.some(function (r) { return r.bust !== null; });
    var hasLength = unique.some(function (r) { return r.length !== null; });
    var hasHeight = unique.some(function (r) { return r.height !== null; });
    var extras = Array.from(new Set(unique.map(function (r) { return r.extras; }).filter(Boolean)));
    var hasDifferentExtras = extras.length > 1;

    var table = document.createElement("table");
    table.className = "pe-size-table";
    var caption = document.createElement("caption");
    caption.textContent = "Garment measurements by size";
    table.appendChild(caption);
    var thead = document.createElement("thead");
    var header = document.createElement("tr");
    header.appendChild(makeCell("th", "Size", "pe-size-table__size"));
    if (hasBust) header.appendChild(makeCell("th", "Bust (in)"));
    if (hasLength) header.appendChild(makeCell("th", "Length (in)"));
    if (hasHeight) header.appendChild(makeCell("th", "Fits height"));
    if (hasDifferentExtras) header.appendChild(makeCell("th", "Includes"));
    thead.appendChild(header);
    table.appendChild(thead);

    var tbody = document.createElement("tbody");
    unique.forEach(function (r) {
      var tr = document.createElement("tr");
      tr.dataset.size = r.size.toLowerCase();
      var rowHeading = makeCell("th", r.size, "pe-size-table__size");
      rowHeading.scope = "row";
      tr.appendChild(rowHeading);
      if (hasBust) tr.appendChild(makeCell("td", r.bust ? r.bust + "″" : "—"));
      if (hasLength) tr.appendChild(makeCell("td", r.length ? r.length + "″" : "—"));
      if (hasHeight) tr.appendChild(makeCell("td", r.height || "—"));
      if (hasDifferentExtras) tr.appendChild(makeCell("td", r.extras || "—"));
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);

    var frag = document.createDocumentFragment();
    frag.appendChild(table);

    if (extras.length === 1) {
      var included = document.createElement("p");
      included.className = "pe-size-table__included";
      included.textContent = "Included: " + extras[0];
      frag.appendChild(included);
    }

    // Preserve any authored product-specific notes, including fit guidance.
    var notes = source.querySelectorAll("ul, ol");
    notes.forEach(function (note) {
      var copy = note.cloneNode(true);
      copy.classList.add("pe-size-table__notes");
      frag.appendChild(copy);
    });

    // Do not change source text, metafields, product price, or variant controls.
    source.replaceChildren(frag);
    details.dataset.peChartReady = "1";
  }

  function updateSelectedRow(details) {
    var table = details.querySelector(".pe-size-table");
    if (!table) return;
    var fitOption = details.closest(".pe-pdp-fit-option");
    if (!fitOption) return;
    var checked = fitOption.querySelector(".block-swatch__radio:checked + .block-swatch__item, .block-swatch__item.is-selected");
    var selected = checked ? checked.textContent.trim().toLowerCase() : "";
    table.querySelectorAll("tbody tr").forEach(function (row) {
      row.classList.toggle("pe-size-table__selected", !!selected && row.dataset.size === selected);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll(".pe-pdp-size-disclosure").forEach(function (details) {
      renderChart(details);
      updateSelectedRow(details);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); }, { once: true });
  else init();

  document.addEventListener("toggle", function (event) {
    var details = event.target;
    if (details && details.matches && details.matches(".pe-pdp-size-disclosure")) {
      renderChart(details);
      updateSelectedRow(details);
    }
  }, true);
  document.addEventListener("change", function (event) {
    var parent = event.target && event.target.closest ? event.target.closest(".pe-pdp-fit-option") : null;
    if (parent) parent.querySelectorAll(".pe-pdp-size-disclosure").forEach(updateSelectedRow);
  }, true);
  document.addEventListener("shopify:section:load", function (event) { init(event.target); });
})();
